// ─── Labels ───────────────────────────────────────────────────────────────────

export const COP_SITE_DETAILS_LABELS = {
    CUSTOMER_SITE_NAME: 'Customer Site Name',
    INDUSTRY_USAGE: 'Industry Usage',
    OWNER: 'Owner',
    OPERATOR: 'Operator',
    CONTACT: 'Contact',
    GEOLOCATION: 'Geolocation',
    SITE_ID: 'Site ID',
    SITE_STATUS: 'Site Status',
} as const

// ─── Error messages ───────────────────────────────────────────────────────────

export const COP_SITE_DETAILS_ERROR = {
    FETCH_FAILED: 'Unable to load site details. Please try again later.',
    EXPORT_FAILED: 'Export failed. Please try again later.',
    NO_SITE_ID: 'No site ID found. Please navigate to this page from the sites list.',
} as const

// ─── Export options ───────────────────────────────────────────────────────────

export const COP_SITE_DETAILS_EXPORT = {
    EXCEL: 'Export As Excel',
    PDF: 'Export As PDF',
    DEFAULT_LABEL: 'Export As',
} as const

// ─── Button types ─────────────────────────────────────────────────────────────

export const COP_SITE_DETAILS_BUTTON_TYPE = {
    DROPDOWN: 'dropdown',
    CTA: 'cta',
} as const

// ─── Accessibility labels ─────────────────────────────────────────────────────

export const COP_SITE_DETAILS_ACCESSIBILITY = {
    FACTORY_ARIA_LABEL: 'Factory',
    WARNING_ARIA_LABEL: 'Warning',
    EXPORT_ARIA_LABEL: 'Export site as',
    EXPORT_MENU_ARIA_LABEL: 'Export options',
    SECTION_ARIA_LABEL: 'Site Details',
    MAP_ARIA_LABEL: 'Map',
} as const
